import { useSuspenseLoginQuery } from 'ap-graphql';
import { useMemo } from 'react';

export const useLoginInfoSuspense = () => {
  const { data, error } = useSuspenseLoginQuery();
  if (error) throw error;
  return useMemo(() => ({ ...data }), [data]);
};
